import { PageLayoutHeaderFooterIcon } from './PageLayoutHeaderFooterIcon';

/**
 * author: Michael Irigoyen
 * id C1258752-7002-4714-81E3-D90828B5A896
 * name page-layout-header-footer
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/page-layout-header-footer.svg
 * tags
 */
export const PageLayoutMarginalsIcon = PageLayoutHeaderFooterIcon;
export default PageLayoutMarginalsIcon